import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Sidebar.css';

const FAMILY_LINKS = [
  { to: '/eventos', label: 'Eventos', icon: '⚔️' },
  { to: '/mis-reservas', label: 'Mis reservas', icon: '🎟️' },
  { to: '/portal', label: 'Portal', icon: '📖' },
  { to: '/perfil', label: 'Perfil', icon: '👤' },
];

const MODERATOR_LINKS = [
  { to: '/moderador', label: 'Mis eventos', icon: '📋' },
  { to: '/perfil', label: 'Perfil', icon: '👤' },
];

const ADMIN_LINKS = [
  { to: '/admin', label: 'Panel', icon: '📊' },
  { to: '/admin/eventos', label: 'Eventos', icon: '🎪' },
  { to: '/admin/reservas', label: 'Reservas', icon: '🎟️' },
  { to: '/admin/calendario-reservas', label: 'Calendario reservas', icon: '🗓️' },
  { to: '/admin/estancias', label: 'Estancias', icon: '🏨' },
  { to: '/admin/alojamientos', label: 'Alojamientos', icon: '🛏️' },
  { to: '/admin/calendario', label: 'Calendario', icon: '📆' },
  { to: '/admin/usuarios', label: 'Usuarios', icon: '👥' },
  { to: '/admin/whatsapp', label: 'WhatsApp', icon: '💬' },
  { to: '/admin/preguntas', label: 'Preguntas', icon: '❓' },
  { to: '/admin/hospederias', label: 'Hospederias', icon: '🛂' },
  { to: '/admin/incidencias', label: 'Incidencias', icon: '🏥' },
  { to: '/admin/personas', label: 'Personas', icon: '👤' },
  { to: '/admin/portal', label: 'Portal familias', icon: '📖' },
  { to: '/perfil', label: 'Perfil', icon: '⚙️' },
];

// Rol limitado: solo la pestaña de Incidencias.
const INCIDENCIAS_LINKS = [
  { to: '/admin/incidencias', label: 'Incidencias', icon: '🏥' },
  { to: '/perfil', label: 'Perfil', icon: '⚙️' },
];

const ROUTE_LABELS = {
  '/eventos': 'Eventos',
  '/mis-reservas': 'Mis reservas',
  '/mis-personas': 'Mis personas',
  '/portal': 'Portal',
  '/perfil': 'Perfil',
  '/admin': 'Panel',
  '/admin/eventos': 'Eventos',
  '/admin/reservas': 'Reservas',
  '/admin/campamento': 'Campamento web',
  '/admin/roster': 'Roster semanal',
  '/admin/estancias': 'Estancias',
  '/admin/alojamientos': 'Alojamientos',
  '/admin/calendario': 'Calendario',
  '/admin/calendario-reservas': 'Calendario de reservas',
  '/admin/usuarios': 'Usuarios',
  '/admin/whatsapp': 'WhatsApp',
  '/admin/preguntas': 'Preguntas',
  '/admin/hospederias': 'Hospederias',
  '/admin/incidencias': 'Incidencias',
  '/admin/personas': 'Personas',
  '/admin/portal': 'Portal familias',
  '/moderador': 'Mis eventos',
};

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const links = user?.role === 'admin' ? ADMIN_LINKS
    : user?.role === 'incidencias' ? INCIDENCIAS_LINKS
    : user?.role === 'moderator' ? MODERATOR_LINKS : FAMILY_LINKS;
  const currentLabel = ROUTE_LABELS[location.pathname] || 'Aldealix';

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <>
      {/* Header móvil */}
      <div className="mobile-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <img src="/logo.svg" alt="Aldealix" style={{ height: 24, width: 'auto', filter: 'invert(1)' }} />
          <div>
            <div className="mobile-header-title">⚔ {currentLabel}</div>
            <div className="mobile-header-user">{user?.email}</div>
          </div>
        </div>
        <div style={{ fontSize: '.7rem', color: 'rgba(122,171,138,.5)', letterSpacing: '.3rem' }}>ᚠᚢᚦ</div>
      </div>

      <aside className="sidebar">
        <div className="sidebar-brand">
          <img src="/logo.svg" alt="Aldealix" style={{ height: 36, width: 'auto', filter: 'invert(1)', marginBottom: 4 }} />
          <div className="sidebar-rune">ᚠᚢᚦᚨᚱ</div>
          <div className="sidebar-name">Aldealix</div>
          <div className="sidebar-sub">La Aldea Celta</div>
        </div>

        <div className="sidebar-user">
          <div className="sidebar-user-avatar">
            {user?.email?.charAt(0)?.toUpperCase() || '?'}
          </div>
          <div>
            <div className="sidebar-user-name">{user?.email}</div>
          </div>
        </div>

        <nav className="sidebar-nav">
          {links.map(({ to, label, icon }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/admin'}
              className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
            >
              <span className="sidebar-icon">{icon}</span>
              {label}
            </NavLink>
          ))}
        </nav>

        <button className="sidebar-logout" onClick={handleLogout}>
          <span>⟵</span> Cerrar sesión
        </button>
      </aside>
    </>
  );
}
